import React, { useMemo } from 'react';
import {
  EQUIPMENT_NEED_OPTIONS,
  parseEquipmentNeed,
  serializeEquipmentNeed,
} from '../lib/equipmentNeed';

/**
 * 需求設備：複選（原生控件，不依賴 antd）。
 * value / onChange 仍用換行分隔字串，與既有 equipment_need 欄位相容。
 */
export default function EquipmentNeedMultiSelect({
  label = '需求設備',
  value,
  onChange,
  inputStyle,
  disabled,
}) {
  const { selected, otherText } = useMemo(() => parseEquipmentNeed(value), [value]);

  const emit = (nextSelected, nextOther) => {
    onChange?.(serializeEquipmentNeed(nextSelected, nextOther));
  };

  const toggle = (opt) => {
    if (disabled) return;
    const next = selected.includes(opt)
      ? selected.filter((x) => x !== opt)
      : [...selected, opt];
    emit(next, opt === '其他' && selected.includes(opt) ? '' : otherText);
  };

  return (
    <div style={{ marginBottom: 12 }}>
      {label ? (
        <div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>{label}</div>
      ) : null}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 14px' }}>
        {EQUIPMENT_NEED_OPTIONS.map((opt) => (
          <label
            key={opt}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              fontSize: 14,
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            <input
              type="checkbox"
              disabled={disabled}
              checked={selected.includes(opt)}
              onChange={() => toggle(opt)}
            />
            {opt}
          </label>
        ))}
      </div>
      {selected.includes('其他') ? (
        <input
          type="text"
          disabled={disabled}
          value={otherText}
          placeholder="其他設備說明（選填）"
          onChange={(e) => emit(selected, e.target.value)}
          style={{
            width: '100%',
            marginTop: 8,
            padding: '8px 10px',
            fontSize: 14,
            border: '1px solid #d1d5db',
            borderRadius: 6,
            boxSizing: 'border-box',
            ...(inputStyle || {}),
          }}
        />
      ) : null}
    </div>
  );
}
